"use client";

import { capturePixelEvent } from "@/lib/pixel";
import { usePixelStore } from "@/stores/pixel";
import { usePathname } from "next/navigation";
import Script from "next/script";
import { useEffect } from "react";

export default function Pixel() {
  const isPixelLoaded = usePixelStore((state) => state.isPixelLoaded);
  const setIsPixelLoaded = usePixelStore((state) => state.setIsPixelLoaded);

  const pathname = usePathname();

  useEffect(() => {
    if (!isPixelLoaded) return;

    capturePixelEvent("ViewContent");
  }, [pathname, isPixelLoaded]);

  return (
    <Script
      id="fb-pixel"
      src="/scripts/pixel.js"
      strategy="lazyOnload"
      onLoad={() => {
        setIsPixelLoaded(true);
      }}
      data-pixel-id={process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID}
    />
  );
}
